import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

export interface ModalityChangeDevice {
  mac: string;
  currentVersion: string;
  currentLabel: string;
  targetVersion: string;
  targetLabel: string;
  warning?: boolean;
}

export interface ConfirmDialogData {
  type: 'reinstall' | 'downgrade' | 'modality-change';
  devices: { mac: string; currentVersion: string; targetVersion: string }[] | ModalityChangeDevice[];
}

@Component({
  selector: 'app-firmware-confirm-dialog',
  templateUrl: './firmware-confirm-dialog.component.html',
  styleUrls: ['./firmware-confirm-dialog.component.scss']
})
export class FirmwareConfirmDialogComponent {
  constructor(
    public dialogRef: MatDialogRef<FirmwareConfirmDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: ConfirmDialogData
  ) {}

  get modalityDevices(): ModalityChangeDevice[] {
    return this.data.devices as ModalityChangeDevice[];
  }

  // Un mismo lote puede tener equipos migrando a modalidades distintas
  // (ej. uno a Bus de Datos y otro a Zigbee); el mensaje se interpola solo
  // cuando todos comparten la misma modalidad destino.
  get uniqueTargetLabels(): string[] {
    return [...new Set(this.modalityDevices.map((d) => d.targetLabel))];
  }

  get hasZigbeeWarning(): boolean {
    return this.modalityDevices.some((d) => d.warning);
  }
}
